import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'


const ExplorePage = () => {


	return (
		<main className="grid flex-1 items-start gap-4 p-4 sm:px-6 sm:py-0 md:gap-8 lg:grid-cols-3 xl:grid-cols-4">
			<div className="grid auto-rows-max items-start gap-4 md:gap-8 lg:col-span-4">
				<Card>
					<CardHeader className="px-7">
						<CardTitle>Auctions</CardTitle>
						<CardDescription>
							Recently setteled Auctions.
						</CardDescription>
					</CardHeader>
					<CardContent>
						<Table>
							<TableHeader>
								<TableRow>
									<TableHead>Time</TableHead>
									<TableHead className="hidden sm:table-cell">
										Website
									</TableHead>
									<TableHead className="hidden sm:table-cell">
										Publisher
									</TableHead>
									<TableHead className="hidden md:table-cell">
										Ad Campaign
									</TableHead>
									<TableHead className="text-right">Winning Price</TableHead>
								</TableRow>
							</TableHeader>
							<TableBody>
								<TableRow className="bg-accent">
									<TableCell className="hidden md:table-cell">
										2023-06-23:505
									</TableCell>
									<TableCell>
										<div className="font-medium">Liam Johnson</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											liam@example.com
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										11111111111....11111111111
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										11111111111....11111111111
									</TableCell>
									<TableCell className="text-right">$250.00</TableCell>
								</TableRow>
								<TableRow className="bg-accent">
									<TableCell className="hidden md:table-cell">
										2023-06-23:505
									</TableCell>
									<TableCell>
										<div className="font-medium">Liam Johnson</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											liam@example.com
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										11111111111....11111111111
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										11111111111....11111111111
									</TableCell>
									<TableCell className="text-right">$250.00</TableCell>
								</TableRow>
								<TableRow className="bg-accent">
									<TableCell className="hidden md:table-cell">
										2023-06-23:505
									</TableCell>
									<TableCell>
										<div className="font-medium">Liam Johnson</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											liam@example.com
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										11111111111....11111111111
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										11111111111....11111111111
									</TableCell>
									<TableCell className="text-right">$250.00</TableCell>
								</TableRow>
								<TableRow className="bg-accent">
									<TableCell className="hidden md:table-cell">
										2023-06-23:505
									</TableCell>
									<TableCell>
										<div className="font-medium">Liam Johnson</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											liam@example.com
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										11111111111....11111111111
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										11111111111....11111111111
									</TableCell>
									<TableCell className="text-right">$250.00</TableCell>
								</TableRow>
								<TableRow className="bg-accent">
									<TableCell className="hidden md:table-cell">
										2023-06-23:505
									</TableCell>
									<TableCell>
										<div className="font-medium">Liam Johnson</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											liam@example.com
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										11111111111....11111111111
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										11111111111....11111111111
									</TableCell>
									<TableCell className="text-right">$250.00</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</CardContent>
				</Card>
			</div>
			<div className="auto-rows-max items-start gap-4 md:gap-8 lg:col-span-2">
				<Card>
					<CardHeader className="px-7">
						<CardTitle>Publishers</CardTitle>
						<CardDescription>
							Publisher websites working with us.
						</CardDescription>
					</CardHeader>
					<CardContent>
						<Table>
							<TableHeader>
								<TableRow>
									<TableHead>Website</TableHead>
									<TableHead className="hidden sm:table-cell">
										Available RE
									</TableHead>
									<TableHead className="hidden sm:table-cell">
										# frames
									</TableHead>
									<TableHead className="hidden md:table-cell">
										Publihser PK
									</TableHead>
								</TableRow>
							</TableHeader>
							<TableBody>
								<TableRow className="bg-accent">
									<TableCell>
										<div className="font-medium">Hermit.io</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											Pomodoro timer
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										300 cpx
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										1
									</TableCell>
									<TableCell className="hidden md:table-cell">
										11111....1111
									</TableCell>
								</TableRow>
								<TableRow className="bg-accent">
									<TableCell>
										<div className="font-medium">Hermit.io</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											Pomodoro timer
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										300 cpx
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										1
									</TableCell>
									<TableCell className="hidden md:table-cell">
										11111....1111
									</TableCell>
								</TableRow>
								<TableRow className="bg-accent">
									<TableCell>
										<div className="font-medium">Hermit.io</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											Pomodoro timer
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										300 cpx
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										1
									</TableCell>
									<TableCell className="hidden md:table-cell">
										11111....1111
									</TableCell>
								</TableRow>
								<TableRow className="bg-accent">
									<TableCell>
										<div className="font-medium">Hermit.io</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											Pomodoro timer
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										300 cpx
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										1
									</TableCell>
									<TableCell className="hidden md:table-cell">
										11111....1111
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</CardContent>
				</Card>
			</div>
			<div className="auto-rows-max items-start gap-4 md:gap-8 lg:col-span-2">
				<Card>
					<CardHeader className="px-7">
						<CardTitle>Ad Campaigns</CardTitle>
						<CardDescription>
							Most recently launched Ad Campaigns.
						</CardDescription>
					</CardHeader>
					<CardContent>
						<Table>
							<TableHeader>
								<TableRow>
									<TableHead>Ad Campaign Name</TableHead>
									<TableHead className="hidden sm:table-cell">
										Brand
									</TableHead>
									<TableHead className="hidden md:table-cell">
										Ad Campaign PK
									</TableHead>
								</TableRow>
							</TableHeader>
							<TableBody>
								<TableRow className="bg-accent">
									<TableCell>
										<div className="font-medium">Vitamin B-12</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											cvs.com
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										Nature Made
									</TableCell>
									<TableCell className="hidden md:table-cell">
										11111....1111
									</TableCell>
								</TableRow>
								<TableRow className="bg-accent">
									<TableCell>
										<div className="font-medium">Vitamin B-12</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											cvs.com
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										Nature Made
									</TableCell>
									<TableCell className="hidden md:table-cell">
										11111....1111
									</TableCell>
								</TableRow>
								<TableRow className="bg-accent">
									<TableCell>
										<div className="font-medium">Vitamin B-12</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											cvs.com
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										Nature Made
									</TableCell>
									<TableCell className="hidden md:table-cell">
										11111....1111
									</TableCell>
								</TableRow>
								<TableRow className="bg-accent">
									<TableCell>
										<div className="font-medium">Vitamin B-12</div>
										<div className="hidden text-sm text-muted-foreground md:inline">
											cvs.com
										</div>
									</TableCell>
									<TableCell className="hidden sm:table-cell">
										Nature Made
									</TableCell>
									<TableCell className="hidden md:table-cell">
										11111....1111
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</CardContent>
				</Card>
			</div>
		</main>
	)
}

export default ExplorePage
